import type { PropsWithChildren } from "react";
import { Card, CardContent } from "@shared-kernel/primary/shared/shadcn/ui/card";
import { cn } from "@components/utils/utils";

interface FormCardProps {
  className?: string;
}

/**
 * FormCard - Simple card wrapper for forms
 *
 * Use this component to wrap forms in detail pages.
 * It provides consistent padding and styling without a header/title.
 *
 * @example
 * ```tsx
 * <FormCard>
 *   <MyForm onSubmit={handleSubmit} />
 * </FormCard>
 * ```
 */
export const FormCard = ({ children, className }: PropsWithChildren<FormCardProps>) => {
  return (
    <Card className={cn("pt-6", className)}>
      <CardContent>{children}</CardContent>
    </Card>
  );
};
